// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const ACTIVITIES = [
  { id: 1, type: "Deal Updated", description: "Moved Apex Insurance Brokers deal to Negotiation stage", who: "Lucas Mason", when: "10 min ago", timeGroup: "today", icon: "$$", link: "Deals Pipeline" },
  { id: 2, type: "Task Completed", description: "Completed: AR reconciliation for January", who: "Clorice Robertson", when: "25 min ago", timeGroup: "today", icon: "OK", link: "Task Board" },
  { id: 3, type: "Meeting Scheduled", description: "Scheduled demo with Prairie Fleet Services for Feb 12", who: "Lucas Mason", when: "1 hr ago", timeGroup: "today", icon: "CAL", link: "Client Meetings" },
  { id: 4, type: "New Contact Added", description: "Added Priya Sharma from BeautyBliss Salons to CRM", who: "Lucas Mason", when: "2 hrs ago", timeGroup: "today", icon: "+U", link: "Contacts" },
  { id: 5, type: "Document Uploaded", description: "Uploaded Q1 Revenue Forecast Model v3 for board review", who: "Taylor Schenher", when: "2 hrs ago", timeGroup: "today", icon: "DOC", link: "Projects" },
  { id: 6, type: "Sprint Started", description: "Sprint 13 kicked off with 48 point capacity", who: "Jordan Lutz", when: "3 hrs ago", timeGroup: "today", icon: "SPR", link: "Sprints" },
  { id: 7, type: "Task Completed", description: "Completed: Board presentation Q1 slides - financial section", who: "Taylor Schenher", when: "4 hrs ago", timeGroup: "today", icon: "OK", link: "Task Board" },
  { id: 8, type: "Deal Updated", description: "Updated Canstorr deal value from $40K to $45K", who: "Tyson Becker", when: "5 hrs ago", timeGroup: "today", icon: "$$", link: "Deals Pipeline" },
  { id: 9, type: "Meeting Scheduled", description: "Rescheduled Western Mining demo to Feb 10 at 2 PM", who: "Lee Mehling", when: "6 hrs ago", timeGroup: "today", icon: "CAL", link: "Client Meetings" },
  { id: 10, type: "New Contact Added", description: "Added James Whitfield from SK Cattle Ranch", who: "Tyson Becker", when: "Yesterday 4:30 PM", timeGroup: "yesterday", icon: "+U", link: "Contacts" },
  { id: 11, type: "Task Completed", description: "Completed: Mining site visit report for Western Mining", who: "Lee Mehling", when: "Yesterday 3:15 PM", timeGroup: "yesterday", icon: "OK", link: "Task Board" },
  { id: 12, type: "Document Uploaded", description: "Uploaded Canstorr partnership draft agreement v2", who: "Tyson Becker", when: "Yesterday 2:00 PM", timeGroup: "yesterday", icon: "DOC", link: "Projects" },
  { id: 13, type: "Deal Updated", description: "Moved HealthFirst Clinics to Closed-Won - $48K deal", who: "Des Bachynski", when: "Yesterday 11:30 AM", timeGroup: "yesterday", icon: "$$", link: "Deals Pipeline" },
  { id: 14, type: "Task Completed", description: "Completed: Health platform beta build deployment", who: "Jordan Lutz", when: "Yesterday 10:00 AM", timeGroup: "yesterday", icon: "OK", link: "Task Board" },
  { id: 15, type: "Meeting Scheduled", description: "Scheduled onboarding session with HealthFirst Clinics", who: "Des Bachynski", when: "Yesterday 9:00 AM", timeGroup: "yesterday", icon: "CAL", link: "Client Meetings" },
  { id: 16, type: "Sprint Started", description: "Sprint 12 completed with 42 points delivered", who: "Jordan Lutz", when: "Feb 7 5:00 PM", timeGroup: "this-week", icon: "SPR", link: "Sprints" },
  { id: 17, type: "Document Uploaded", description: "Uploaded updated sales deck with Q4 case studies", who: "Lucas Mason", when: "Feb 7 2:30 PM", timeGroup: "this-week", icon: "DOC", link: "Projects" },
  { id: 18, type: "New Contact Added", description: "Added Tom Bradley from Pacific Tire Warehouse", who: "Lucas Mason", when: "Feb 6 4:00 PM", timeGroup: "this-week", icon: "+U", link: "Contacts" },
  { id: 19, type: "Deal Updated", description: "Created new deal: BeautyBliss Salons - $12K for GlowDesk", who: "Lucas Mason", when: "Feb 6 11:00 AM", timeGroup: "this-week", icon: "$$", link: "Deals Pipeline" },
  { id: 20, type: "Task Completed", description: "Completed: Security audit follow-ups from Q4 report", who: "Tyler Hodgson", when: "Feb 5 3:00 PM", timeGroup: "this-week", icon: "OK", link: "Task Board" },
];

const TYPES = ["All", "Deal Updated", "Task Completed", "Meeting Scheduled", "New Contact Added", "Document Uploaded", "Sprint Started"];
const TEAM = ["All", "Jordan Lutz", "Ryan Miskulin", "Taylor Schenher", "Des Bachynski", "Lucas Mason", "Lee Mehling", "Clorice Robertson", "Tyson Becker", "Tyler Hodgson"];

export default function ActivityFeedPage() {
  const [typeFilter, setTypeFilter] = useState("All");
  const [memberFilter, setMemberFilter] = useState("All");

  const filtered = ACTIVITIES.filter(a => {
    if (typeFilter !== "All" && a.type !== typeFilter) return false;
    if (memberFilter !== "All" && a.who !== memberFilter) return false;
    return true;
  });

  const todayActivities = filtered.filter(a => a.timeGroup === "today");
  const yesterdayActivities = filtered.filter(a => a.timeGroup === "yesterday");
  const weekActivities = filtered.filter(a => a.timeGroup === "this-week");

  const typeIcon = (type) => {
    const icons = {
      "Deal Updated": { bg: "#10b98122", color: "#10b981", label: "$$" },
      "Task Completed": { bg: "#3b82f622", color: "#3b82f6", label: "OK" },
      "Meeting Scheduled": { bg: "#8b5cf622", color: "#8b5cf6", label: "CAL" },
      "New Contact Added": { bg: "#ec489922", color: "#ec4899", label: "+U" },
      "Document Uploaded": { bg: "#f9731622", color: "#f97316", label: "DOC" },
      "Sprint Started": { bg: "#eab30822", color: "#eab308", label: "SPR" },
    };
    return icons[type] || { bg: "#64748b22", color: "#64748b", label: "?" };
  };

  const typeCounts = TYPES.slice(1).map(t => ({ type: t, count: ACTIVITIES.filter(a => a.type === t).length }));

  const renderActivity = (activity) => {
    const icon = typeIcon(activity.type);
    return (
      <div key={activity.id} style={{ display: "flex", gap: 14, padding: "14px 0", borderBottom: "1px solid #1e293b" }}>
        <div style={{ width: 40, height: 40, borderRadius: 8, background: icon.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: icon.color, flexShrink: 0 }}>
          {icon.label}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, color: "#e2e8f0", lineHeight: 1.5 }}>{activity.description}</div>
          <div style={{ display: "flex", gap: 12, marginTop: 4, fontSize: 12 }}>
            <span style={{ color: "#10b981", fontWeight: 600 }}>{activity.who}</span>
            <span style={{ color: "#64748b" }}>{activity.when}</span>
            <span style={{ color: "#334155" }}>|</span>
            <span style={{ color: "#3b82f6", fontSize: 11 }}>{activity.link}</span>
          </div>
        </div>
        <span className="badge" style={{ background: icon.bg, color: icon.color, alignSelf: "flex-start", fontSize: 10 }}>{activity.type}</span>
      </div>
    );
  };

  return (
    <div>
      <div className="page-header">
        <div><h1>Activity Feed</h1><p>Company-wide activity stream</p></div>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Today</div><div className="stat-value">{ACTIVITIES.filter(a => a.timeGroup === "today").length}</div><div style={{ fontSize: 12, color: "#64748b" }}>activities</div></div>
        <div className="stat-card"><div className="stat-label">This Week</div><div className="stat-value">{ACTIVITIES.length}</div></div>
        <div className="stat-card"><div className="stat-label">Most Active</div><div className="stat-value" style={{ fontSize: 16, color: "#10b981" }}>Lucas Mason</div><div style={{ fontSize: 12, color: "#64748b" }}>{ACTIVITIES.filter(a => a.who === "Lucas Mason").length} activities</div></div>
        <div className="stat-card"><div className="stat-label">Top Activity</div><div className="stat-value" style={{ fontSize: 16, color: "#3b82f6" }}>Tasks</div><div style={{ fontSize: 12, color: "#64748b" }}>{ACTIVITIES.filter(a => a.type === "Task Completed").length} completed</div></div>
      </div>

      {/* Filters */}
      <div className="card" style={{ display: "flex", gap: 12, alignItems: "center", padding: "12px 20px", flexWrap: "wrap" }}>
        <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} style={{ padding: "8px 12px", background: "#0f172a", border: "1px solid #334155", borderRadius: 6, color: "#e2e8f0", fontSize: 13 }}>
          {TYPES.map(t => <option key={t} value={t}>{t === "All" ? "All Activity Types" : t}</option>)}
        </select>
        <select value={memberFilter} onChange={e => setMemberFilter(e.target.value)} style={{ padding: "8px 12px", background: "#0f172a", border: "1px solid #334155", borderRadius: 6, color: "#e2e8f0", fontSize: 13 }}>
          {TEAM.map(t => <option key={t} value={t}>{t === "All" ? "All Team Members" : t}</option>)}
        </select>
        {(typeFilter !== "All" || memberFilter !== "All") && (
          <button className="btn btn-outline btn-sm" onClick={() => { setTypeFilter("All"); setMemberFilter("All"); }}>Clear Filters</button>
        )}
        <span style={{ marginLeft: "auto", fontSize: 13, color: "#64748b" }}>Showing {filtered.length} of {ACTIVITIES.length} activities</span>
      </div>

      {/* Feed by Time Group */}
      {todayActivities.length > 0 && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-header"><h3>Today</h3><span className="card-badge" style={{ background: "#10b981" }}>{todayActivities.length}</span></div>
          {todayActivities.map(renderActivity)}
        </div>
      )}

      {yesterdayActivities.length > 0 && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-header"><h3>Yesterday</h3><span className="card-badge">{yesterdayActivities.length}</span></div>
          {yesterdayActivities.map(renderActivity)}
        </div>
      )}

      {weekActivities.length > 0 && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-header"><h3>Earlier This Week</h3><span className="card-badge">{weekActivities.length}</span></div>
          {weekActivities.map(renderActivity)}
        </div>
      )}

      {filtered.length === 0 && (
        <div className="card" style={{ marginTop: 16, textAlign: "center", padding: 40 }}>
          <div style={{ fontSize: 15, color: "#64748b" }}>No activities match your filters.</div>
        </div>
      )}

      {/* Activity Type Breakdown */}
      <div className="card" style={{ marginTop: 16 }}>
        <div className="card-header"><h3>Activity Type Breakdown</h3></div>
        <div className="chart-bar-container">
          {typeCounts.sort((a, b) => b.count - a.count).map(tc => {
            const icon = typeIcon(tc.type);
            return (
              <div key={tc.type} className="chart-bar-row">
                <span className="chart-bar-label" style={{ width: 140 }}>{tc.type}</span>
                <div className="chart-bar-track">
                  <div className="chart-bar-fill" style={{ width: (tc.count / ACTIVITIES.length * 100) + "%", background: icon.color }}>{tc.count}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Team Activity */}
      <div className="card" style={{ marginTop: 16 }}>
        <div className="card-header"><h3>Team Activity This Week</h3></div>
        {TEAM.slice(1).map(person => {
          const count = ACTIVITIES.filter(a => a.who === person).length;
          return count > 0 ? (
            <div key={person} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid #334155" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#10b981", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: "#fff" }}>
                  {person.split(" ").map(n => n[0]).join("")}
                </div>
                <span style={{ fontSize: 13, color: "#e2e8f0" }}>{person}</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 80, height: 6, background: "#334155", borderRadius: 3 }}>
                  <div style={{ width: (count / 8 * 100) + "%", height: 6, background: "#10b981", borderRadius: 3 }} />
                </div>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#10b981" }}>{count}</span>
              </div>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
}
